// Plain client-side SPA entry — used by `npm run build:spa` with vite.config.spa.ts.
// No SSR, no TanStack Start, no Nitro. Mounts the existing TanStack Router into #root.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import "./styles.css";
import { getRouter } from "./router";

const router = getRouter();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);